// extracted by mini-css-extract-plugin
export default {"main":"border_main__pIcwJ","border":"border_border__NTdGZ","titlesmain":"border_titlesmain__2-oYS"};